<template>
  <div>
    <VasionSchedulersPage title="Full Text Update" />
  </div>
</template>

<script>
export default {
  name: 'AutomationEngineFullTextUpdate',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
